export const iconFontAwesomeMediaplaybackExpand = (
	<i className="fa-solid fa-expand"></i>
);
